var UNDEF = "undefined";
export var version = "%%build:version%%";
export var isBrowser = typeof window != UNDEF && typeof document != UNDEF;
if (!isBrowser) {
    console.log("Rangy can only run in a browser");
}
export var features = {
    implementsDomRange: true,
    implementsTextRange: false,
    htmlParsingConforms: true,
    crashyTextNodes: false,
    implementsWinGetSelection: true,
    implementsDocSelection: false,
    selectionSupportsMultipleRanges: false,
    implementsControlRange: false,
};
/** @deprecated all configs is const! */
export var config = {
    preferTextRange: false,
    checkSelectionRanges: true,
};
// RangePrototype,
// rangePrototype: new RangePrototype(),
// selectionPrototype: new SelectionPrototype(),
export function onDocReady(listener) {
    if (!isBrowser)
        return;
    if (document.readyState == "complete") {
        listener();
    }
    else {
        var onLoaded_1 = function () {
            document.removeEventListener("DOMContentLoaded", onLoaded_1, false);
            listener();
        };
        document.addEventListener("DOMContentLoaded", onLoaded_1, false);
    }
}
//# sourceMappingURL=api.js.map